import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

export const Privacy = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <div className="min-h-screen pt-32 pb-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">{t.privacy.title}</h1>
        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-6">{t.privacy.content}</p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              {language === 'tr' ? '1. Toplanan Bilgiler' : '1. Information Collected'}
            </h2>
            <p className="text-gray-600 mb-4">
              {language === 'tr'
                ? 'Web sitemizi ziyaret ettiğinizde, otomatik olarak IP adresiniz, tarayıcı türü ve ziyaret saati gibi teknik bilgiler toplanır. İletişim formlarını doldurduğunuzda, adınız, e-posta adresiniz ve telefon numaranız gibi kişisel bilgiler toplanır.'
                : 'When you visit our website, technical information such as your IP address, browser type, and visit time is automatically collected. When you fill out contact forms, personal information such as your name, email address, and phone number is collected.'}
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              {language === 'tr' ? '2. Bilgilerin Kullanımı' : '2. Use of Information'}
            </h2>
            <p className="text-gray-600 mb-4">
              {language === 'tr'
                ? 'Toplanan bilgiler, size daha iyi hizmet sunmak, sorularınızı yanıtlamak ve hizmetlerimizi geliştirmek için kullanılır. Bilgileriniz üçüncü şahislarla paylaşılmaz.'
                : 'The information collected is used to provide you with better service, answer your questions, and improve our services. Your information is not shared with third parties.'}
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              {language === 'tr' ? '3. Güvenlik' : '3. Security'}
            </h2>
            <p className="text-gray-600 mb-4">
              {language === 'tr'
                ? 'Kişisel bilgilerinizin güvenliği bizim için önemlidir. Uygun teknik ve yönetsel önlemler alarak verilerinizi koruruz.'
                : 'The security of your personal information is important to us. We protect your data by taking appropriate technical and administrative measures.'}
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              {language === 'tr' ? '4. İletişim' : '4. Contact'}
            </h2>
            <p className="text-gray-600">
              {language === 'tr'
                ? 'Gizlilik politikamız hakkında sorularınız varsa, lütfen bizimle iletişime geçin: info@nanogen.com.tr'
                : 'If you have questions about our privacy policy, please contact us: info@nanogen.com.tr'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
